// Données de référence pour les couleurs avec texte RGAA
export interface ColorOption {
  value: string;
  label: string;
  color: string; // Couleur hex pour l'affichage
  textColor: string; // Couleur du texte pour le contraste RGAA
}

export const COLORS: ColorOption[] = [
  { value: 'rouge', label: 'Rouge', color: '#ef4444', textColor: '#ffffff' },
  { value: 'bleu', label: 'Bleu', color: '#3b82f6', textColor: '#ffffff' },
  { value: 'vert', label: 'Vert', color: '#10b981', textColor: '#ffffff' },
  { value: 'jaune', label: 'Jaune', color: '#f59e0b', textColor: '#000000' },
  { value: 'orange', label: 'Orange', color: '#f97316', textColor: '#ffffff' },
  { value: 'violet', label: 'Violet', color: '#8b5cf6', textColor: '#ffffff' },
  { value: 'rose', label: 'Rose', color: '#ec4899', textColor: '#ffffff' },
  { value: 'blanc', label: 'Blanc', color: '#ffffff', textColor: '#000000' },
  { value: 'noir', label: 'Noir', color: '#000000', textColor: '#ffffff' },
  { value: 'gris', label: 'Gris', color: '#6b7280', textColor: '#ffffff' },
  { value: 'marron', label: 'Marron', color: '#92400e', textColor: '#ffffff' },
  { value: 'beige', label: 'Beige', color: '#f3f4f6', textColor: '#000000' },
  { value: 'turquoise', label: 'Turquoise', color: '#06b6d4', textColor: '#ffffff' },
  { value: 'lime', label: 'Lime', color: '#84cc16', textColor: '#000000' },
  { value: 'indigo', label: 'Indigo', color: '#6366f1', textColor: '#ffffff' }
];

// Fonction pour obtenir une couleur par sa valeur
export const getColorByValue = (value: string): ColorOption | undefined => {
  return COLORS.find(color => color.value === value);
};

// Fonction pour obtenir les classes Tailwind pour une couleur
export const getColorClasses = (color: ColorOption) => {
  return {
    bg: `bg-[${color.color}]`,
    text: `text-[${color.textColor}]`,
    border: `border-[${color.color}]`
  };
};
